import React, {useContext} from 'react';
import compact from 'lodash/compact';
import concat from 'lodash/concat';

import {Select} from 'components';
import * as utils from 'utils';

import styles from './FilterIndustries.module.scss';
import Context from '../../../../context';
import {reducerFilters} from '../../../../reducers';
import {sortByNameWithOther} from '../../../../helpers';

export const FilterIndustries = () => {
  const {
    data,
    loading,
    filters: {industries},
    dispatchFilters,
  } = useContext(Context);

  const allIndustries = data.map(item => item.industry);
  const arrOptions = compact([...new Set(concat(...allIndustries))]);
  const sortedOptions = sortByNameWithOther(arrOptions);
  const options = sortedOptions.map(label => ({
    value: `industries--${label}`,
    label,
  }));

  const handleChange = values => {
    // Tracking Analytics
    const items = values.map(item => item.label).join(', ');
    utils.handleAnalytics('dropdown', 'industries', items);

    dispatchFilters({
      type: reducerFilters.actionTypes.updateIndustries,
      payload: values || [],
    });
  };

  return (
    <Select
      className={styles.wrap}
      multiple
      placeholder="All Industries"
      controlAmountText="industries"
      value={industries}
      options={options}
      loading={loading}
      onChange={handleChange}
    />
  );
};

FilterIndustries.defaultProps = {};

FilterIndustries.propTypes = {};
